import { Flex, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { Layout } from "../../components/Layout/Layout";
import { MainAnalyticBlock } from "../../components/AnalyticsBlocks/MainAnalyticBlock";
import { VacanciesList } from "../VacanciesPage/list";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RecruiterAnalytics } from "../../components/RecruiterAnalytics/RecruiterAnalytics";
import { ChakraTabs } from "../../components/tabs/ChakraTabs";
import { useAppDispatch } from "../../store";
import { resetAnalyticsFilters } from "../../store/slices/analytics";

export const AnalyticsPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabIndex, setTabIndex] = useState(Number(searchParams.get("tab") || 0));

  useEffect(() => {
    const initialTabIndex = Number(searchParams.get("tab") || 0);
    setTabIndex(initialTabIndex);
  }, [searchParams]);

  // Сбрасываем фильтры при размонтировании компонента (выходе со страницы)
  useEffect(() => {
    return () => {
      dispatch(resetAnalyticsFilters());
    };
  }, [dispatch]);

  const setDefaultTabParam = (index: number): void => {
    setTabIndex(index);
    if (index === 0) {
      searchParams.delete("tab");
    } else {
      searchParams.set("tab", String(index));
    }
    setSearchParams(searchParams);
  };

  return (
    <Layout>
      <Flex flexDirection="column" overflow="none" maxH="90vh" overflowY="auto">
        <Text fontSize="27px" fontWeight={500} color="#050505">
          Аналитика
        </Text>
        <Tabs index={tabIndex} onChange={setDefaultTabParam} isLazy lazyBehavior="unmount">
          <ChakraTabs
            tabs={[
              { id: "0", label: "Вакансии (общая сводка)" },
              { id: "1", label: "Вакансии (воронка)" },
              { id: "2", label: "Рекрутеры" },
            ]}
            baseUrl="/analytics"
          />
          <TabPanels paddingTop="0">
            <TabPanel paddingX={0}>
              <MainAnalyticBlock isActive={tabIndex === 0} />
            </TabPanel>
            <TabPanel paddingX={0}>
              <VacanciesList isActive={tabIndex === 1} />
            </TabPanel>
            <TabPanel paddingX={0}>
              <RecruiterAnalytics isActive={tabIndex === 2} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Layout>
  );
};
